var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.047 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".reset_svg__a{fill:none;stroke:currentColor;stroke-linecap:square;stroke-miterlimit:10;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 0 0 0 18h0a9 9 0 0 0 6.794-14.9",
    className: "reset_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2.00024px",
    d: "m14.437 7.268 2.002-3.605 4.123.07",
    className: "reset_svg__a"
  })));
};
export default SvgReset;